export class NumberOfEmployeesOption {
  value: number;
  text: string;
}
